/**
 * Copyright (c) Microsoft. All rights reserved.
 */

import React from 'react';
import { EditableTitle } from 'src/core/components/EditableTitle';
import { Page } from 'src/core/components/Page';

export const MyStoragePage = () => (
    <Page size="container-fluid" pageName="MyStoragePage" title="My storage">
        <EditableTitle title="My storage" />
    </Page>
);
